import { CancelToken } from 'axios'

import { portalApi } from '@/axios'

import { PaymentJob } from '@/classes/models'

export default class PaymentJobService {
  /**
   * Get all payment jobs.
   *
   * @param {Context} context
   * @param {TableRequest} parameters
   *
   * @return {Promise}
   */
  static getAll (context, parameters) {
    const cancelToken = CancelToken.source()

    let request = portalApi.get(this.endpoint(context), {
      cancelToken: cancelToken.token,
      params: parameters ? parameters.getParams() : null
    }).then(response => {
      return response.data
    })

    // Map to PaymentJob
    request.then(response => {
      response.data = response.data.map(paymentJob => new PaymentJob(paymentJob))

      return response
    }).catch(error => {
      return Promise.reject(error)
    })

    return { request, cancelToken }
  }

  /**
   * Get a payment job by reference.
   *
   * @param {Context} context
   * @param {string} reference
   *
   * @return {Promise}
   */
  static get (context, reference) {
    let request = portalApi.get(`${this.endpoint(context)}/${reference}`).then(response => {
      return response.data
    })

    return request.then(response => {
      // Map to PaymentJob
      response.data = new PaymentJob(response.data)

      return response
    }).catch(error => {
      return Promise.reject(error)
    })
  }

  static sendPaymentLinkEmail (context, reference, paymentReference, emailAddress) {
    return portalApi.post(`${this.endpoint(context)}/${reference}/payments/${paymentReference}/actions/mail-payment-link`, { emailAddress })
  }

  /**
   * Endpoint of API.
   *
   * @param {Context} context
   *
   * @return {string}
   */
  static endpoint (context) {
    return `${context.endpoint(['business', 'merchant', 'configuration'])}/payment-jobs`
  }
}
